import React from 'react'

import Top from './Top.js'
import Bot from './Bot.js'

import {
  HeaderBlockWrapper,
  HeaderBlockText,
  HeaderHat,
  SubText,
  HeaderChildren,
  HeaderGraphic,
  SpanText,
} from './HeaderBlock.styles'

const HeaderBlock = ({
  headerText,
  graphic,
  subText,
  bgColor,
  children,
  height,
  position,
  pad,
  mobilePad,
  inverse,
  secondary,
  accent,
  noHat,
  headMax,
  horizontalAlign,
  textAlign,
  subMax,
  spanText,
  wavy,
  staticSpan,
  maxGraphicWidth,
  breakP,
  showHead,
}) => (
  <HeaderBlockWrapper
    bgColor={bgColor}
    secondary={secondary}
    inverse={inverse}
    pad={pad}
    mobilePad={mobilePad}
    blockHeight={height}
    position={position}
    horizontalAlign={horizontalAlign}
    textAlign={textAlign}
  >
    {!!wavy && (
      <div className="svg-outer top">
        <div className="svg-wrapper">
          <Top />
        </div>
      </div>
    )}
    {showHead && <HeaderHat inverse={inverse} accent={accent} />}
    {!!headerText && (
      <>
        {!noHat && <HeaderHat inverse={inverse} accent={accent} />}
        <HeaderBlockText
          headMax={headMax}
          secondary={secondary}
          inverse={inverse}
        >
          {headerText}
          {spanText && (
            <SpanText breakP={breakP}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 217 70">
                <path
                  className="path"
                  fill="none"
                  stroke="#505aff"
                  strokeLinecap="round"
                  strokeWidth="3"
                  d="M98.598 2C44.422 3.551 2 17.702 2 34.93 2 53.193 49.682 68 108.5 68S215 53.194 215 34.93c0-17.446-47.96-29.463-103.119-30.709 0 0-14.087 0-24.23 3.15"
                />
              </svg>
              <h2>{spanText}</h2>
            </SpanText>
          )}
          {staticSpan && <span>{staticSpan}</span>}
        </HeaderBlockText>
      </>
    )}

    {!!graphic && (
      <HeaderGraphic maxGraphicWidth={maxGraphicWidth}>{graphic}</HeaderGraphic>
    )}
    {!!subText && <SubText subMax={subMax}>{subText}</SubText>}
    {!!children && <HeaderChildren>{children}</HeaderChildren>}
    {!!wavy && (
      <div className="svg-outer bot">
        <div className="svg-wrapper">
          <Bot />
        </div>
      </div>
    )}
  </HeaderBlockWrapper>
)

export default HeaderBlock
